// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".glRs2K9r\\+WttTYcQcojzpg\\=\\={display:flex;flex-direction:column;gap:20px;margin-top:20px}.CgrpMo1WulAX7mRHyiF1qQ\\=\\={margin:10px 0}", "",{"version":3,"sources":["webpack://./resources/assets/js/react/components/comments/list/style.module.scss"],"names":[],"mappings":"AAAA,6BACE,YAAA,CACA,qBAAA,CACA,QAAA,CACA,eACF,CAEA,4BACE,aACF","sourcesContent":[".list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.noComments {\r\n  margin: 10px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "glRs2K9r+WttTYcQcojzpg==",
	"noComments": "CgrpMo1WulAX7mRHyiF1qQ=="
};
export default ___CSS_LOADER_EXPORT___;
